export const MAX_QUERY_RETRIES = 3;
